if (!customElements.get('richtext-steps')) {
  customElements.define(
    'richtext-steps',
    class RichtextSteps extends HTMLElement {
      constructor() {
        super();
        this.isScrolling = false;
        this.steps = this.getSteps();
      }

      getSteps() {
        return this.querySelectorAll('[data-richtext-step]');
      }

      connectedCallback() {
        window.addEventListener('scroll', () => this.scrollEvent());
      }

      scrollEvent() {
        if (!this.isScrolling) {
          this.isScrolling = true;
          requestAnimationFrame(() => this.handleScroll());
        }
      }

      handleScroll() {        
        this.steps.forEach((step, index) => {
          const rect = step.getBoundingClientRect();
          const stepBorder = step.querySelector('[data-richtext-border]');
          const animationStart = window.innerHeight / 2;
          const animationEnd = animationStart - rect.height;

          if(rect.top <= animationStart && rect.top >= animationEnd) {
            const stepBorderHeight = animationStart - rect.top;
            stepBorder.style.height = `${stepBorderHeight}px`;
          }

          if(rect.top <= animationStart && rect.top < animationEnd) {
            stepBorder.style.height = `100%`;
          }

          if(rect.top > animationStart) {
            stepBorder.style.height = `0px`;
          }
        });

        this.isScrolling = false;
      }
    }
  );
}